var map = {
	"./1-apex.png": "./src/assets/images/pages/1-apex.png",
	"./2-stack.png": "./src/assets/images/pages/2-stack.png",
	"./3-convex.png": "./src/assets/images/pages/3-convex.png",
	"./4-materialize.png": "./src/assets/images/pages/4-materialize.png",
	"./404.png": "./src/assets/images/pages/404.png",
	"./500.png": "./src/assets/images/pages/500.png",
	"./arrow-down.png": "./src/assets/images/pages/arrow-down.png",
	"./auth-v1-bottom-bg.png": "./src/assets/images/pages/auth-v1-bottom-bg.png",
	"./auth-v1-top-bg.png": "./src/assets/images/pages/auth-v1-top-bg.png",
	"./avatar/Avarat-01.png": "./src/assets/images/pages/avatar/Avarat-01.png",
	"./avatar/Avarat-02_dark.png": "./src/assets/images/pages/avatar/Avarat-02_dark.png",
	"./avatar/Avarat-02_light.png": "./src/assets/images/pages/avatar/Avarat-02_light.png",
	"./avatar/Avarat-03_dark.png": "./src/assets/images/pages/avatar/Avarat-03_dark.png",
	"./avatar/Avarat-03_light.png": "./src/assets/images/pages/avatar/Avarat-03_light.png",
	"./avatar/Avarat-04.png": "./src/assets/images/pages/avatar/Avarat-04.png",
	"./avatar/Avarat-05_dark.png": "./src/assets/images/pages/avatar/Avarat-05_dark.png",
	"./avatar/Avarat-05_light.png": "./src/assets/images/pages/avatar/Avarat-05_light.png",
	"./avatar/Avarat-06_dark.png": "./src/assets/images/pages/avatar/Avarat-06_dark.png",
	"./avatar/Avarat-06_light.png": "./src/assets/images/pages/avatar/Avarat-06_light.png",
	"./avatar/Avarat-07_dark.png": "./src/assets/images/pages/avatar/Avarat-07_dark.png",
	"./avatar/Avarat-07_light.png": "./src/assets/images/pages/avatar/Avarat-07_light.png",
	"./avatar/Avarat-08_dark.png": "./src/assets/images/pages/avatar/Avarat-08_dark.png",
	"./avatar/Avarat-08_light.png": "./src/assets/images/pages/avatar/Avarat-08_light.png",
	"./avatar/Avarat-09.png": "./src/assets/images/pages/avatar/Avarat-09.png",
	"./avatar/Avarat-10.png": "./src/assets/images/pages/avatar/Avarat-10.png",
	"./avatar/Avarat-11.png": "./src/assets/images/pages/avatar/Avarat-11.png",
	"./avatar/Avarat-12.png": "./src/assets/images/pages/avatar/Avarat-12.png",
	"./avatar/Avarat-13.png": "./src/assets/images/pages/avatar/Avarat-13.png",
	"./avatar/Avarat-14.png": "./src/assets/images/pages/avatar/Avarat-14.png",
	"./avatar/Avarat-15.png": "./src/assets/images/pages/avatar/Avarat-15.png",
	"./avatar/Avarat-16.png": "./src/assets/images/pages/avatar/Avarat-16.png",
	"./avatar/Avarat-17.png": "./src/assets/images/pages/avatar/Avarat-17.png",
	"./background_violet-small.jpg": "./src/assets/images/pages/background_violet-small.jpg",
	"./background_yellow-small.jpg": "./src/assets/images/pages/background_yellow-small.jpg",
	"./calendar-illustration.png": "./src/assets/images/pages/calendar-illustration.png",
	"./card-image-4.jpg": "./src/assets/images/pages/card-image-4.jpg",
	"./card-image-5.jpg": "./src/assets/images/pages/card-image-5.jpg",
	"./card-image-6.jpg": "./src/assets/images/pages/card-image-6.jpg",
	"./card-img-overlay.jpg": "./src/assets/images/pages/card-img-overlay.jpg",
	"./carousel/faq.jpg": "./src/assets/images/pages/carousel/faq.jpg",
	"./carousel/login1.png": "./src/assets/images/pages/carousel/login1.png",
	"./carousel/logout.PNG": "./src/assets/images/pages/carousel/logout.PNG",
	"./carousel/register.PNG": "./src/assets/images/pages/carousel/register.PNG",
	"./carousel/user.PNG": "./src/assets/images/pages/carousel/user.PNG",
	"./coming-soon-dark.svg": "./src/assets/images/pages/coming-soon-dark.svg",
	"./coming-soon.svg": "./src/assets/images/pages/coming-soon.svg",
	"./content-img-1.jpg": "./src/assets/images/pages/content-img-1.jpg",
	"./content-img-2.jpg": "./src/assets/images/pages/content-img-2.jpg",
	"./content-img-3.jpg": "./src/assets/images/pages/content-img-3.jpg",
	"./content-img-4.jpg": "./src/assets/images/pages/content-img-4.jpg",
	"./eCommerce/1.png": "./src/assets/images/pages/eCommerce/1.png",
	"./eCommerce/10.png": "./src/assets/images/pages/eCommerce/10.png",
	"./eCommerce/11.png": "./src/assets/images/pages/eCommerce/11.png",
	"./eCommerce/12.png": "./src/assets/images/pages/eCommerce/12.png",
	"./eCommerce/13.png": "./src/assets/images/pages/eCommerce/13.png",
	"./eCommerce/14.png": "./src/assets/images/pages/eCommerce/14.png",
	"./eCommerce/15.png": "./src/assets/images/pages/eCommerce/15.png",
	"./eCommerce/16.png": "./src/assets/images/pages/eCommerce/16.png",
	"./eCommerce/17.png": "./src/assets/images/pages/eCommerce/17.png",
	"./eCommerce/18.png": "./src/assets/images/pages/eCommerce/18.png",
	"./eCommerce/19.png": "./src/assets/images/pages/eCommerce/19.png",
	"./eCommerce/2.png": "./src/assets/images/pages/eCommerce/2.png",
	"./eCommerce/20.png": "./src/assets/images/pages/eCommerce/20.png",
	"./eCommerce/21.png": "./src/assets/images/pages/eCommerce/21.png",
	"./eCommerce/22.png": "./src/assets/images/pages/eCommerce/22.png",
	"./eCommerce/23.png": "./src/assets/images/pages/eCommerce/23.png",
	"./eCommerce/24.png": "./src/assets/images/pages/eCommerce/24.png",
	"./eCommerce/25.png": "./src/assets/images/pages/eCommerce/25.png",
	"./eCommerce/26.png": "./src/assets/images/pages/eCommerce/26.png",
	"./eCommerce/27.png": "./src/assets/images/pages/eCommerce/27.png",
	"./eCommerce/3.png": "./src/assets/images/pages/eCommerce/3.png",
	"./eCommerce/4.png": "./src/assets/images/pages/eCommerce/4.png",
	"./eCommerce/5.png": "./src/assets/images/pages/eCommerce/5.png",
	"./eCommerce/6.png": "./src/assets/images/pages/eCommerce/6.png",
	"./eCommerce/7.png": "./src/assets/images/pages/eCommerce/7.png",
	"./eCommerce/8.png": "./src/assets/images/pages/eCommerce/8.png",
	"./eCommerce/9.png": "./src/assets/images/pages/eCommerce/9.png",
	"./eCommerce/alienware-laptop.jpg": "./src/assets/images/pages/eCommerce/alienware-laptop.jpg",
	"./eCommerce/amazon-chromecast.jpg": "./src/assets/images/pages/eCommerce/amazon-chromecast.jpg",
	"./eCommerce/amazon-echodot.jpg": "./src/assets/images/pages/eCommerce/amazon-echodot.jpg",
	"./eCommerce/amazon-firestick.jpg": "./src/assets/images/pages/eCommerce/amazon-firestick.jpg",
	"./eCommerce/amazon-google-home.jpg": "./src/assets/images/pages/eCommerce/amazon-google-home.jpg",
	"./eCommerce/apple-Imac.jpg": "./src/assets/images/pages/eCommerce/apple-Imac.jpg",
	"./eCommerce/apple-ear-pods.jpg": "./src/assets/images/pages/eCommerce/apple-ear-pods.jpg",
	"./eCommerce/apple-macbook.jpg": "./src/assets/images/pages/eCommerce/apple-macbook.jpg",
	"./eCommerce/asus-desktop.jpg": "./src/assets/images/pages/eCommerce/asus-desktop.jpg",
	"./eCommerce/bank.png": "./src/assets/images/pages/eCommerce/bank.png",
	"./eCommerce/bower-and-wilkins-speaker.jpg": "./src/assets/images/pages/eCommerce/bower-and-wilkins-speaker.jpg",
	"./eCommerce/canon-camera.jpg": "./src/assets/images/pages/eCommerce/canon-camera.jpg",
	"./eCommerce/dell-inspirion.jpg": "./src/assets/images/pages/eCommerce/dell-inspirion.jpg",
	"./eCommerce/garmin-watch.jpg": "./src/assets/images/pages/eCommerce/garmin-watch.jpg",
	"./eCommerce/garmin-watch2.jpg": "./src/assets/images/pages/eCommerce/garmin-watch2.jpg",
	"./eCommerce/phillips-smart-led.jpg": "./src/assets/images/pages/eCommerce/phillips-smart-led.jpg",
	"./eCommerce/samsung-fridge.jpg": "./src/assets/images/pages/eCommerce/samsung-fridge.jpg",
	"./eCommerce/sharp-50.jpg": "./src/assets/images/pages/eCommerce/sharp-50.jpg",
	"./eCommerce/sony-75class-tv.jpg": "./src/assets/images/pages/eCommerce/sony-75class-tv.jpg",
	"./eCommerce/sony-headphones.jpg": "./src/assets/images/pages/eCommerce/sony-headphones.jpg",
	"./error-dark.svg": "./src/assets/images/pages/error-dark.svg",
	"./error.svg": "./src/assets/images/pages/error.svg",
	"./faq.jpg": "./src/assets/images/pages/faq.jpg",
	"./forgot-password-v2-dark.svg": "./src/assets/images/pages/forgot-password-v2-dark.svg",
	"./forgot-password-v2.svg": "./src/assets/images/pages/forgot-password-v2.svg",
	"./forgot-password.png": "./src/assets/images/pages/forgot-password.png",
	"./graphic-1.png": "./src/assets/images/pages/graphic-1.png",
	"./graphic-2.png": "./src/assets/images/pages/graphic-2.png",
	"./graphic-3.png": "./src/assets/images/pages/graphic-3.png",
	"./graphic-4.png": "./src/assets/images/pages/graphic-4.png",
	"./graphic-5.png": "./src/assets/images/pages/graphic-5.png",
	"./graphic-6.png": "./src/assets/images/pages/graphic-6.png",
	"./kb-article.jpg": "./src/assets/images/pages/kb-article.jpg",
	"./kb-image.jpg": "./src/assets/images/pages/kb-image.jpg",
	"./knowledge-base-cover.jpg": "./src/assets/images/pages/knowledge-base-cover.jpg",
	"./lock-screen.png": "./src/assets/images/pages/lock-screen.png",
	"./login-v2-dark.svg": "./src/assets/images/pages/login-v2-dark.svg",
	"./login-v2.svg": "./src/assets/images/pages/login-v2.svg",
	"./login.png": "./src/assets/images/pages/login.png",
	"./login/facebook.svg": "./src/assets/images/pages/login/facebook.svg",
	"./login/github.svg": "./src/assets/images/pages/login/github.svg",
	"./login/google.svg": "./src/assets/images/pages/login/google.svg",
	"./login/twitter.svg": "./src/assets/images/pages/login/twitter.svg",
	"./maintenance-2.png": "./src/assets/images/pages/maintenance-2.png",
	"./maintenance.png": "./src/assets/images/pages/maintenance.png",
	"./modern.jpg": "./src/assets/images/pages/modern.jpg",
	"./not-authorized-dark.svg": "./src/assets/images/pages/not-authorized-dark.svg",
	"./not-authorized.svg": "./src/assets/images/pages/not-authorized.svg",
	"./opt-trans-black-big.png": "./src/assets/images/pages/opt-trans-black-big.png",
	"./opt-trans-white-big.png": "./src/assets/images/pages/opt-trans-white-big.png",
	"./ozp-trans-blacktext-medium.png": "./src/assets/images/pages/ozp-trans-blacktext-medium.png",
	"./ozp-trans-whitetext-medium.png": "./src/assets/images/pages/ozp-trans-whitetext-medium.png",
	"./pixinvent-logo.png": "./src/assets/images/pages/pixinvent-logo.png",
	"./register-v2-dark.svg": "./src/assets/images/pages/register-v2-dark.svg",
	"./register-v2.svg": "./src/assets/images/pages/register-v2.svg",
	"./register.jpg": "./src/assets/images/pages/register.jpg",
	"./reset-password-v2-dark.svg": "./src/assets/images/pages/reset-password-v2-dark.svg",
	"./reset-password-v2.svg": "./src/assets/images/pages/reset-password-v2.svg",
	"./reset-password.png": "./src/assets/images/pages/reset-password.png",
	"./rocket.png": "./src/assets/images/pages/rocket.png",
	"./search-result.jpg": "./src/assets/images/pages/search-result.jpg",
	"./two-steps-verification-illustration-dark.svg": "./src/assets/images/pages/two-steps-verification-illustration-dark.svg",
	"./two-steps-verification-illustration.svg": "./src/assets/images/pages/two-steps-verification-illustration.svg",
	"./under-maintenance-dark.svg": "./src/assets/images/pages/under-maintenance-dark.svg",
	"./under-maintenance.svg": "./src/assets/images/pages/under-maintenance.svg",
	"./verify-email-illustration-dark.svg": "./src/assets/images/pages/verify-email-illustration-dark.svg",
	"./verify-email-illustration.svg": "./src/assets/images/pages/verify-email-illustration.svg",
	"./video-poster.jpg": "./src/assets/images/pages/video-poster.jpg",
	"./vuexy-login-bg.jpg": "./src/assets/images/pages/vuexy-login-bg.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/pages sync recursive ^\\.\\/.*$";